var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.984,
    height: 40,
    viewBox: "0 0 39.984 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#0e265e;}.d{fill:#658bce;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(0 0.0002)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 39.984,
    height: 40
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Compliance Local Outreach-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M33.313,1.6018a5.0746,5.0746,0,0,1,5.071,5.069v26.658A5.0763,5.0763,0,0,1,33.313,38.4H6.671A5.0776,5.0776,0,0,1,1.6,33.3288V6.6708a5.0759,5.0759,0,0,1,5.071-5.069H33.313m0-1.602H6.671A6.6714,6.6714,0,0,0,0,6.6708v26.658A6.6707,6.6707,0,0,0,6.671,40H33.313a6.67,6.67,0,0,0,6.671-6.671V6.6708A6.6707,6.6707,0,0,0,33.313,0",
    transform: "translate(0 0.0002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M19.9084,32.2376a7.2127,7.2127,0,1,1,6.98-9.048,7.2189,7.2189,0,0,1-6.98,9.048m.011-13.517a6.311,6.311,0,1,0,3.167.861,6.2851,6.2851,0,0,0-3.167-.861",
    transform: "translate(0 0.0002)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 28.2867,
    y: 27.5161,
    width: 0.9124,
    height: 9.0626,
    transform: "matrix(0.5964, -0.8027, 0.8027, 0.5964, -14.1235, 36.0046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M32.3794,35.5741a.82.82,0,0,1-.491-.163l-4.481-3.33a.8237.8237,0,1,1,.983-1.322l4.481,3.33a.8239.8239,0,0,1-.492,1.485",
    transform: "translate(0 0.0002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.086,25.7108A13.7076,13.7076,0,0,1,9.335,8.5338l.334-.36.334.36a12.9444,12.9444,0,0,0,4.007,2.927l.356.168-.113.377a21.7515,21.7515,0,0,0-.899,5.902l-.912-.015a22.8247,22.8247,0,0,1,.829-5.778,13.8626,13.8626,0,0,1-3.59-2.599,12.7887,12.7887,0,0,0-.845,15.675Z",
    transform: "translate(0 0.0002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.0993,12.5116l-.478-.225a13.8494,13.8494,0,0,1-4.286-3.131l-.288-.311.288-.311a13.9335,13.9335,0,0,1,8.479-4.344l1.258-.157-.87.921a17.7266,17.7266,0,0,0-3.95,7.052Zm-3.798-3.667A12.95,12.95,0,0,0,13.54,11.23a19.0032,19.0032,0,0,1,3.147-5.919,13.03,13.03,0,0,0-6.386,3.534",
    transform: "translate(0 0.0002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M31.0308,25.7108l-.75-.52a12.8009,12.8009,0,0,0-.849-15.675,13.8715,13.8715,0,0,1-3.49,2.549,22.8521,22.8521,0,0,1,.847,5.916l-.912.013a21.8582,21.8582,0,0,0-.916-6.035l-.114-.375.353-.169a12.9634,12.9634,0,0,0,3.91-2.88l.334-.359.334.359a13.7179,13.7179,0,0,1,1.253,17.176",
    transform: "translate(0 0.0002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M25.1143,12.4665l-.154-.508a17.7083,17.7083,0,0,0-3.916-6.984l-.879-.936,1.273.171a13.9591,13.9591,0,0,1,8.34,4.325l.288.31-.288.311a13.8776,13.8776,0,0,1-4.184,3.082Zm-2.544-7.12a18.966,18.966,0,0,1,3.099,5.831,12.9124,12.9124,0,0,0,3.143-2.333,13.06,13.06,0,0,0-6.242-3.498",
    transform: "translate(0 0.0002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M25.8765,17.994a21.9478,21.9478,0,0,0-.771-5.533,13.78,13.78,0,0,1-5.093,1.151V15.7h-.912V12.708h.456A12.9322,12.9322,0,0,0,25.2,11.415l.479-.231.155.509a22.7472,22.7472,0,0,1,.955,6.287Z",
    transform: "translate(0 0.0002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M13.354,17.9081l-.912-.016a22.6491,22.6491,0,0,1,.938-6.15l.152-.506.478.225a12.9491,12.9491,0,0,0,5.546,1.247h.456V15.7H19.1v-2.088a13.86,13.86,0,0,1-4.991-1.107,21.9833,21.9833,0,0,0-.755,5.403",
    transform: "translate(0 0.0002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M20.0126,13.62h-.456a13.8572,13.8572,0,0,1-5.934-1.333l-.356-.168.113-.377a18.6234,18.6234,0,0,1,4.159-7.413l.112-.119.163-.02a13.7194,13.7194,0,0,1,1.743-.121h.456Zm-5.641-1.995a12.9387,12.9387,0,0,0,4.729,1.075V4.9908c-.313.014-.645.041-1.011.084a17.641,17.641,0,0,0-3.718,6.55",
    transform: "translate(0 0.0002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M19.5562,13.62H19.1V4.0691h.456a13.9453,13.9453,0,0,1,1.88.141l.161.021.111.118a18.6323,18.6323,0,0,1,4.125,7.344l.114.375-.353.169a13.8509,13.8509,0,0,1-6.038,1.383m.456-8.629V12.7a12.9325,12.9325,0,0,0,4.83-1.12,17.6451,17.6451,0,0,0-3.688-6.487c-.417-.053-.791-.086-1.142-.102",
    transform: "translate(0 0.0002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ecd05b217c7396e5df8b0c39b5e15dd0.svg";
export { ForwardRef as ReactComponent };